webpackJsonp([37],{

/***/ "/GbR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("hQg2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0lxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = topicListApi;
/* harmony export (immutable) */ __webpack_exports__["g"] = topicInfoApi;
/* harmony export (immutable) */ __webpack_exports__["e"] = articleListApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = articleLikeApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = articleInfoApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = articleCommentListApi;
/* harmony export (immutable) */ __webpack_exports__["a"] = articleCommentApi;
/* harmony export (immutable) */ __webpack_exports__["f"] = articleNotaryListApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");

/**
 * 获取专题
 */
function topicListApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/topic/list',
    method: 'get'
  });
}
/**
 * 获取专题详情
 */
function topicInfoApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/topic/info',
    method: 'get',
    params: query
  });
}

/**
 * 获取公证知识与问题
 */
function articleListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/list',
    method: 'get',
    params: query
  });
}

/**
 * 点赞文章
 */
function articleLikeApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/like',
    method: 'post',
    data: data
  });
}

/**
 * 获取文章详情
 */
function articleInfoApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/info',
    method: 'get',
    params: query
  });
}

/**
 * 获取文章评论
 */
function articleCommentListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/comment_list',
    method: 'get',
    params: query
  });
}

/**
 * 评论文章
 */
function articleCommentApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/comment',
    method: 'post',
    data: data
  });
}

/**
 * 获取文章相关业务
 */
function articleNotaryListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/article/notary',
    method: 'get',
    params: query
  });
}

/***/ }),

/***/ "2QY3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADMUlEQVRoge3Zz2seRRzH8VeeBrFGUATxRw8WtCASa7wLRqtV8awoItaq0x6F1lKJxUoVrFrp0WcUVAr+BdYoRujBa0FD9dIeFMS2wYOXGCzGepjdsll3nzzJ8+CzkX3DAzsz3535fma/852HmbFut2sQQgiV9THGzdiX/S7jfRwLISyV7IYy/vhAvVQQY+zgWbyFLYWmI9gbY5zBiRDC38MctzPMzmKMO3Aan1gpImdL1nY6sx0aQ/kiMcZJvIPH+nxlCnMxxpM4gB8H9WHQL3JzTEH+nXoRi1iqaXsc8/gANw3iyHqFXINDOIeXsKnCZhkf4g5sw8fSoi+zCXuyvl7D5vU4tNbQ6uA5vIlbe9jN4kAI4UyhbneM8Tjew8MV71wrSwiYwQn0nRDWIuQhHMP2Hjbz2BdCmKtqDCHMY2eM8VG8i8kKszwhvIz9+KYf5/oJrUl8ga/Vi/gVu3FvnYgiIYQvcQ9exPkasynM4XPctVqfYz02xFvwRuZg1RogLeSj0kb3x2qDVRFjnJBm/hVM1Jgt4yO8jovFhnxDrPoiE9kLZ/VeyF3cHkI4sl4RGYvShG2TksNyhc2qCaFTen4hE3BY/eyclEJsr9LsDMh5BCmkZmts8oRwFs8r+J+H1k4pm9zdY6C/pHzf1+IbAjukyeqVkK4kl7FutzsjpdONzMEOXh21F0Ngf0cKmY3OcsfGDys4Oi4t8lncWGo8Lm1aOYfwbU1HB/FIofyptDtXsUv6m5PzFd6usb1PylI530s7fpFfQgjn8ozwQ0Unv5fKZ3CqbBRCEGPcVar+KYTwL1uIMU6Xqi5U9ZtxfYVPK2x7bYgbklZI02iFNI1WSNNohTSNVkjTaIU0jVZI02iFNI1WSNNohTSN/42Q8gHxA7g/e95aantKOilfQXbhX66fjjEerhlzulSekk7/q7izVN5asD2lcDRUvOi5Dgu4qqbTpnEJN4QQFlkZWkv4bSQurY8F/JkXiqF1Sbov3I6x/9iptXJZuhu5cgA/1u12r8bTuG1UXg3Iz/hsXLpkfGbEzgzKgx08MWovhsCTHcO90BwVFzrSte/CqD0ZgIvY8w/npsRDcC3evgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4B0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tabBar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tabBar = ({
  name: 'tabBar',
  data: function data() {
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tabBar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_tabBar = ({
  name: 'tabBar',
  data: function data() {
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2071dc38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbar',[_c('tabbar-item',{attrs:{"link":"/h5/index","selected":_vm.$route.path == '/' || _vm.$route.path == '/h5/index'}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("K/Cy")},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":__webpack_require__("QIbA")},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("首页")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/h5/online","selected":_vm.$route.path == '/h5/online'}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("Ewem")},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":__webpack_require__("p/NS")},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("在线公证")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/h5/org","selected":_vm.$route.path == '/h5/org'}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("2QY3")},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":__webpack_require__("X9gD")},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("公证处")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/h5/guide","selected":_vm.$route.path == '/h5/guide'}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("ULcu")},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":__webpack_require__("FsZP")},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("公证指南")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/h5/my","selected":_vm.$route.path == '/h5/my'}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("gkYO")},slot:"icon"}),_vm._v(" "),_c('img',{attrs:{"slot":"icon-active","src":__webpack_require__("hbRj")},slot:"icon-active"}),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_tabBar = (esExports);
// CONCATENATED MODULE: ./src/components/tabBar.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_tabBar,
  selectortype_template_index_0_src_components_tabBar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_tabBar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ypi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5+/f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Eczl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "68gT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lMn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAYAAABM8m7ZAAACe0lEQVRIiY3WTYiWVRQH8J+vDWkGDuSixA8GWjSl5iYx0EzDtM0IMY4yiwqCI4EudaFgJeFCN4kQzA0lChQ1hEyMIShwiHQhTEMupPxIYQhpoShNNqEunvs2D4/P+/oeeLjnued//3/uxzn3ThsaGtKBLcY6LMcLmIfZOXYH47iE8/geFyLifjvCaW2En8b72ILeSuwGfscDPI8FlfgfOIzPIuKvOvJGTd90bMU1fFoR/RovZ6E1eCMiFua+YyXcQnyMaymlD1NKMx4n3IOfcBDPlPon8Q42YqxKEhFjEbEZg/i3FJqFjzCaUlpSHlNe6tfwDbqrxAh8nv1uxRa8qljqn3EoIm5DSuldfFHDMYGBiDhdFl6JYcysGfCjYllhKc7guQpmHG9FxFgWH8abNVyT2BAR3zXwLE62EIX9uZ2JUzWiMBffppSaHPtacHXhaEppfgN7MacF8B5+yP4g5rfAURy4Tdk/i79b4GZjTwMDbcjGszi80gbXtGUQEZOKlGtl/Q3FAenEOsV1xNXAiTaAuXgy++c7IDwHKaUu7bflSAM7UVtdsmjzRB/D1TZkV3A8+6vwVAvcTexu4E+8rcizOtue2wn0qd+76+iLiH/y/44WXBPoj4ibzco1gvW4VQNerSgg8CtexDYcxZHsvxQRFyGl9B7W1vDcVuT6CI9eEj2ZbHll0KSiWn1VZYuI//2U0qCianVVYBewKSIuNzueqACuYgU+UNTYZr3uwpfYgE8wWh6U6/Auj6bmLezBwYj4rxzo5FoMxfKW7QYum7oWqyf4NyQMRcSdOvLqjMt2Fwfyt8jUQ6BXkWavl2Z10dRDYDgifmnDCx4CeTqu7fwH90sAAAAASUVORK5CYII="

/***/ }),

/***/ "967l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9HX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATIC_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATIC_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return H5_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MATERIAL_VIEW_SIMPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATERIAL_VIEW_FULL; });
var STATIC_VIEW = "https://www.egongzheng.com/h5/online-gzy-api" + '/static_view/';
var STATIC_DOWNLOAD = "https://www.egongzheng.com/h5/online-gzy-api" + '/static_download/';
var H5_INDEX = '/H5/v_indexMobile.htm';
// 材料缩略图
var MATERIAL_VIEW_SIMPLE = "https://www.egongzheng.com/h5/online-gzy-api" + '/auth/material/view?viewType=0';
// 材料原图
var MATERIAL_VIEW_FULL = "https://www.egongzheng.com/h5/online-gzy-api" + '/auth/material/view?viewType=1';

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("L2JU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C296":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CJFh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D5u3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYWH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collectApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = collectListApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");

/**
 * 收藏/取消收藏
 */
function collectApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/collection/collect',
    method: 'post',
    data: data
  });
}

/**
 * 收藏列表
 */
function collectListApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/collection/list',
    method: 'get'
  });
}

/***/ }),

/***/ "Eczl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EwX8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Ewem":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAGbUlEQVRogcXZe7BVdRUH8M+93KsgCob5IAwKi3LykamNCmp1DQFNsyEbG8hmrDNNM83Q1J9p9WdTTTWSDTer6d1oZVDyMJ2awbCyLEUMp5LIyVDzARQkCPTHWpu972Gf+zgP+87sOfv3Wo+z12/91lq/vlWrVukhluJz6MPH8MNuM2g0GqC/24QrmIbPYg5m4zM4rlfMeqnIMZhRaZ+Aqb1i1ktFDuFApX0w+3qCXiqyz0jBD2VfT9BLRWZjsNIezL6eoNuKzMAHcA/WG7m5j8u+e/BBsWe6hm4p0ocP4bf4Kt6GU2rmnZJjwzn3w7m2YxSKHN0Bjen4Ab6C07LvPnF+7K7M2519v872XHwZt+H4dpkPDw8fTSjyNWzE/DbozMRPcG22/4CrcRE+jf2Vufuz70K8E3/M/qVJ4xVt8L8IG4eHh2/tTyHOx2q8dwJE5mMD3pLt72IIa7I91Uiz6VOeI6tz7neyfWnSWjAB/suS1/m4th8rhFs8IYX5KZbg2JrFk3PhLbgbZ2b/SlyP5yYgyLO5ZmW2z0iaq5LH5Jo1x6Zsa/DtlHkfVgwI0/oHvojX4cp8HsPv8aQ42GbgrGQ4KQk/h0/i5gkoUMVBfAR/wafEXmngBjyMh1LhScJRvEnsrQJbsaLRaGwYyI71uCSJvk/4+7lNi6rYhR/h89jSphJVfAm/xEdxjYjTzs6nDo/jG1jZaDSehoHK4FO4EV/A5cL2r8CsHP+X+PSb8DNs64ICVTyI94sv8w7hFIZwUo4/gTuFwuvFlzqMqiIFnsX389mkVOQZXNdFwVvhb8JUb8ZmpSLbhdnVYrQD8QycU2mfhos7EnFiuFDs2QLnpEy1GE2RxcJzHMQL4ust7oKA48ViEZ/9N2WYPBr/Vor046p8v0u4ZGLP1JljtzEpeRH7Yn2+X6WFzK0UmYc35vtt+cAbKv29xJnC1cPtIgQizGte3YJWigyJw2ePCF9+IVzuJC+NeS0RX3538v4V/iMig8vqFrRS5Jr8fQh/Fa53Y/YtVh6IvUC/8s+6F0+Lw/nBJtmOWNSMuTgv39cos7zCTs/D6zsUdjTMw5srPAv+qyv8X9O8qE6RS0Vo/oII5AqsEx5kUHz6XmEJjkr+6yr9d2XfNLy1eVGdIu/K30dEvFNgmzggiZO/F2ly1aw2CbMusKUizxHm1SzMqeIggrVGFgsOKs1rPl7dvrwt8SplXrQ+eRbYL1wxXCDqZYfRrMglIjR+sbKoirVJcDIWdSJxCyzClOS/tmb8zuT/MrEFDqNZkeIQ3KrM4KrYKkJ7wgS6km8n+pRm9Tv8qWbO5kr/1dWBqiInKrO9n2NvDaEDyg14sTDFbmGWMpZbZ2Rxr8BesekJ6zlc4KgqsgAnC3e3WmsUTKaJiki3MCS8ZfXPqsNqIePLVYLYahVlWb5vwW9GIXQ/Hsj35aLG2ymOSVqE6d4/Bv/NBf9qFaVflGUKt/tvo7vWKdiZ70O41ciK4kQxKOpcQ9nelTxaYSBlJBKwW4aHh/v7hZdaVpl4gfDh1wm7HczFM/EeEfdU452leGUHipyKd1fal4lwaGnyHEgZZqWc94kyUIHlOKkIzB4xMok6G98ThYftwp/PScLN+LPIHtvFM3hUWZGBc0XU+0/8XXi02eqrl1uwc0CEHdeL26TmEPnkfFphm8izd44yZyzsShq3O7LYMVP9n1dgK5Y3Go29xV7YjIVCmfHeYdyBtxt9Y44XDyStO8Y5/5DIkRY2Go2HGbmptwtbXYhviapFNUTZhx2iKHGFcA7VWKhTPJY0Fwmz3lHD/4mU7XKxXx8vBuvS1rvzmYbXKu3yKbEfnu+i8HXYkM/xyb+oouxI/rvqFo2Wf+9ShiP/DzxvAmbbyxurlxS9VGSPI+8Q9/SKWSelnelic57oSE93IMerJ/QUfFy46uacv0/k5j/WpitvV5GjxN3GlRNYMwU3jTFnqcj+Jnz7264ipyvz9p3JuN3c5JD4Y6YL13u6smIybrSryCRhPv3iFvdenSmyQJzsB7RZahqPIlOVYUqxF+YoBe/TmdPoa6I1R3nzVfQ/KQp0LTGWIufi66KOVBQCDuW6Yu03RY7dyRcpaA2I678qvX5xo3WDSIFrMZYiNyprsK0wWu7QDuronYVPiNvgWoxlEi92IlGXsX+0wbG+yE0i8elliXQ8eFRcybXE/wANwlpF5rF98QAAAABJRU5ErkJggg=="

/***/ }),

/***/ "FsZP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "G4+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/tP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/api/request.js
var request = __webpack_require__("l/JR");

// CONCATENATED MODULE: ./src/api/dict/index.js

/**
 * 获取全局数据字典
 */
function dictDataApi() {
  return Object(request["a" /* default */])({
    url: '/dict/data',
    method: 'get'
  });
}
// CONCATENATED MODULE: ./src/store/modules/dict/index.js



// initial state
var dict_state = {
  dictData: {},
  locationInfo: {
    areaName: '厦门市',
    parentRegionId: 'p13',
    regionId: 'p13r1'
  },
  loginBackFullPath: ''

  // getters
};var getters = {
  dictData: function dictData(state) {
    return state.dictData;
  },
  loginBackFullPath: function loginBackFullPath(state) {
    return state.loginBackFullPath;
  }

  // actions
};var actions = {
  // 获取全局数据字典
  dictDataAction: function dictDataAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      dictDataApi().then(function (response) {
        if (response.status === '2000') {
          var regionNameMap = {};
          response.data.region.forEach(function (region) {
            regionNameMap[region.name] = region;
          });
          var dictData = response.data;
          dictData.regionNameMap = regionNameMap;
          commit('setDictData', dictData);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 定位信息
  locationInfoAction: function locationInfoAction(_ref2) {
    var commit = _ref2.commit;

    var locationInfo = {};
    return new promise_default.a(function (resolve, reject) {
      locationInfo.areaName = '厦门市';
      locationInfo.parentRegionId = 'p13';
      locationInfo.regionId = 'p13r1';
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000
        });
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete' && result.info === 'SUCCESS') {
            var city = result.addressComponent ? result.addressComponent.city : '';
            if (city && dict_state.dictData.regionNameMap && dict_state.dictData.regionNameMap[city]) {
              locationInfo.areaName = city;
              var region = dict_state.dictData.regionNameMap[city];
              locationInfo.regionId = region.value;
              locationInfo.parentRegionId = region.parent;
            }
            locationInfo.longitude = result.position.lng;
            locationInfo.latitude = result.position.lat;
            commit('setLocationInfo', locationInfo);
          }
        });
      });
      commit('setLocationInfo', locationInfo);
      resolve();
    });
  }
};

// mutations
var mutations = {
  setDictData: function setDictData(state, dictData) {
    state.dictData = dictData;
    window.localStorage.setItem('dictData', stringify_default()(dictData));
  },
  setLocationInfo: function setLocationInfo(state, locationInfo) {
    state.locationInfo = locationInfo;
    window.localStorage.setItem('locationInfo', stringify_default()(locationInfo));
  },
  setLoginBackFullPath: function setLoginBackFullPath(state, loginBackFullPath) {
    state.loginBackFullPath = loginBackFullPath;
  }
};

/* harmony default export */ var dict = ({
  namespaced: true,
  state: dict_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// EXTERNAL MODULE: ./src/api/user/index.js
var user = __webpack_require__("v1eo");

// EXTERNAL MODULE: ./src/auth/auth.js
var auth = __webpack_require__("TWC+");

// CONCATENATED MODULE: ./src/store/modules/user/index.js



// initial state
var user_state = {
  userInfo: {}

  // getters
};var user_getters = {
  userInfo: function userInfo(state) {
    return state.userInfo;
  }

  // actions
};var user_actions = {
  // 登录
  loginAction: function loginAction(_ref, loginData) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(user["e" /* loginApi */])(loginData).then(function (response) {
        if (response.status === '2000') {
          commit('setUserInfo', response.data);
          resolve();
        } else if (response.status === '6666') {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取登录用户信息
  getUserInfoAction: function getUserInfoAction(_ref2) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(user["h" /* userInfoApi */])().then(function (response) {
        if (response.status === '2000') {
          if (response.data) {
            commit('setUserInfo', response.data);
          }
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 登出
  logOutAction: function logOutAction(_ref3) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(auth["b" /* removeToken */])();
      commit('setUserInfo', {});
      resolve();
    });
  }
};

// mutations
var user_mutations = {
  setUserInfo: function setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  }
};

/* harmony default export */ var modules_user = ({
  namespaced: true,
  state: user_state,
  getters: user_getters,
  actions: user_actions,
  mutations: user_mutations
});
// EXTERNAL MODULE: ./src/api/index/index.js
var index = __webpack_require__("RtM3");

// EXTERNAL MODULE: ./src/api/static_api.js
var static_api = __webpack_require__("9HX7");

// CONCATENATED MODULE: ./src/store/modules/index/index.js



// initial state
var index_state = {
  bannerList: [],
  bidHot: {},
  searchResultNotary: {},
  searchResultNotaryList: [],
  searchResultArticle: {},
  searchResultArticleList: [],
  searchHot: []

  // getters
};var index_getters = {};

// actions
var index_actions = {
  // 获取Banner
  bannerListAction: function bannerListAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(index["a" /* bannerListApi */])().then(function (response) {
        var bannerList = [];
        if (response.status === '2000') {
          response.data.forEach(function (banner) {
            if (banner.img && banner.img.length > 0) {
              banner.img = static_api["e" /* STATIC_VIEW */] + banner.img;
              bannerList.push(banner);
            }
          });
          commit('setBannerList', bannerList);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取热门申办
  bidHotAction: function bidHotAction(_ref2) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(index["b" /* bidHotApi */])().then(function (response) {
        if (response.status === '2000') {
          commit('setBidHot', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 搜索公证业务结果
  searchResultNotaryAction: function searchResultNotaryAction(_ref3, query) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return new promise_default.a(function (resolve, reject) {
      Object(index["e" /* searchResultApi */])(query).then(function (response) {
        if (response.status === '2000' && response.data) {
          commit('setSearchResultNotary', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 搜索常见问题结果
  searchResultArticleAction: function searchResultArticleAction(_ref4, query) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new promise_default.a(function (resolve, reject) {
      Object(index["e" /* searchResultApi */])(query).then(function (response) {
        if (response.status === '2000' && response.data) {
          commit('setSearchResultArticle', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 热门搜索标签
  searchHotAction: function searchHotAction(_ref5, query) {
    var commit = _ref5.commit,
        state = _ref5.state;

    return new promise_default.a(function (resolve, reject) {
      Object(index["c" /* searchHotApi */])(query).then(function (response) {
        if (response.status === '2000' && response.data) {
          commit('setSearchHot', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var index_mutations = {
  setBannerList: function setBannerList(state, bannerList) {
    state.bannerList = bannerList;
  },
  setBidHot: function setBidHot(state, bidHot) {
    state.bidHot = bidHot;
  },
  setSearchResultNotary: function setSearchResultNotary(state, searchResultNotary) {
    state.searchResultNotary = searchResultNotary;
  },
  setSearchResultNotaryList: function setSearchResultNotaryList(state, searchResultNotaryList) {
    state.searchResultNotaryList = searchResultNotaryList;
  },
  setSearchResultArticle: function setSearchResultArticle(state, searchResultArticle) {
    state.searchResultArticle = searchResultArticle;
  },
  setSearchResultArticleList: function setSearchResultArticleList(state, searchResultArticleList) {
    state.searchResultArticleList = searchResultArticleList;
  },
  setSearchHot: function setSearchHot(state, searchHot) {
    state.searchHot = searchHot;
  }
};

/* harmony default export */ var modules_index = ({
  namespaced: true,
  state: index_state,
  getters: index_getters,
  actions: index_actions,
  mutations: index_mutations
});
// CONCATENATED MODULE: ./src/api/online/index.js

/**
 * 获取所有用途和产品
 */
function bidUseProductionApi() {
  return Object(request["a" /* default */])({
    url: '/online/bid_use_production',
    method: 'get'
  });
}

/**
 * 获取所有事项
 */
function bidNotaryApi() {
  return Object(request["a" /* default */])({
    url: '/online/bid_notary',
    method: 'get'
  });
}

/**
 * 获取申办说明
 */
function bidDetailApi(query) {
  return Object(request["a" /* default */])({
    url: '/online/detail',
    method: 'get',
    params: query
  });
}
// CONCATENATED MODULE: ./src/store/modules/online/index.js


// initial state
var online_state = {
  bidUseProduction: [],
  bidNotary: [],
  bidDetail: {},
  bidDetailProd: {}

  // getters
};var online_getters = {};

// actions
var online_actions = {
  // 获取所有用途和产品
  bidUseProductionAction: function bidUseProductionAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      bidUseProductionApi().then(function (response) {
        if (response.status === '2000') {
          commit('setBidUseProduction', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取所有事项
  bidNotaryAction: function bidNotaryAction(_ref2) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      bidNotaryApi().then(function (response) {
        if (response.status === '2000') {
          commit('setBidNotary', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取申办说明
  bidDetailAction: function bidDetailAction(_ref3, qurey) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
      bidDetailApi(qurey).then(function (response) {
        if (response.status === '2000') {
          commit('setBidDetail', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取申办说明
  bidDetailProdAction: function bidDetailProdAction(_ref4, qurey) {
    var commit = _ref4.commit;

    return new promise_default.a(function (resolve, reject) {
      bidDetailApi(qurey).then(function (response) {
        if (response.status === '2000') {
          commit('setBidDetailProd', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var online_mutations = {
  setBidUseProduction: function setBidUseProduction(state, bidUseProduction) {
    state.bidUseProduction = bidUseProduction;
  },
  setBidNotary: function setBidNotary(state, bidNotary) {
    state.bidNotary = bidNotary;
  },
  setBidDetail: function setBidDetail(state, bidDetail) {
    state.bidDetail = bidDetail;
  },
  setBidDetailProd: function setBidDetailProd(state, bidDetailProd) {
    state.bidDetailProd = bidDetailProd;
  }
};

/* harmony default export */ var online = ({
  namespaced: true,
  state: online_state,
  getters: online_getters,
  actions: online_actions,
  mutations: online_mutations
});
// CONCATENATED MODULE: ./src/api/org/index.js

/**
 * 获取公证处列表
 */
function orgListApi(query) {
  return Object(request["a" /* default */])({
    url: '/org/list',
    method: 'get',
    params: query
  });
}
/**
 * 获取公证处详情
 */
function orgInfoApi(query) {
  return Object(request["a" /* default */])({
    url: '/org/info',
    method: 'get',
    params: query
  });
}
// CONCATENATED MODULE: ./src/store/modules/org/index.js



// initial state
var org_state = {
  orgList: {},
  orgInfo: {
    orgInfo: {}
  }

  // getters
};var org_getters = {};

// actions
var org_actions = {
  // 获取公证处列表
  orgListAction: function orgListAction(_ref, qurey) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      orgListApi(qurey).then(function (response) {
        if (response.status === '2000') {
          commit('setOrgList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取公证处详情
  orgInfoAction: function orgInfoAction(_ref2, qurey) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      orgInfoApi(qurey).then(function (response) {
        if (response.status === '2000') {
          commit('setOrgInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var org_mutations = {
  setOrgList: function setOrgList(state, orgList) {
    state.orgList = orgList;
  },
  setOrgInfo: function setOrgInfo(state, orgInfo) {
    state.orgInfo = orgInfo;
  }
};

/* harmony default export */ var org = ({
  namespaced: true,
  state: org_state,
  getters: org_getters,
  actions: org_actions,
  mutations: org_mutations
});
// EXTERNAL MODULE: ./src/api/my/collect.js
var collect = __webpack_require__("EYWH");

// CONCATENATED MODULE: ./src/store/modules/my/collect.js


// initial state
var collect_state = {
  collectList: {}

  // getters
};var collect_getters = {};

// actions
var collect_actions = {
  // 收藏列表
  collectListAction: function collectListAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(collect["b" /* collectListApi */])().then(function (response) {
        if (response.status === '2000') {
          commit('setCollectList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var collect_mutations = {
  setCollectList: function setCollectList(state, collectList) {
    state.collectList = collectList;
  }
};

/* harmony default export */ var my_collect = ({
  namespaced: true,
  state: collect_state,
  getters: collect_getters,
  actions: collect_actions,
  mutations: collect_mutations
});
// EXTERNAL MODULE: ./src/api/my/material.js
var material = __webpack_require__("zTws");

// CONCATENATED MODULE: ./src/store/modules/my/material.js




// initial state
var material_state = {
  materialGroupList: []

  // getters
};var material_getters = {
  materialGroupList: function materialGroupList(state) {
    return state.materialGroupList;
  }

  // actions
};var material_actions = {
  // 材料列表
  materialGroupListAction: function materialGroupListAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(material["b" /* materialListApi */])().then(function (response) {
        if (response.status === '2000') {
          response.data.forEach(function (m) {
            var srcList = [];
            m.materialList.forEach(function (materia) {
              var src = {
                src: static_api["b" /* MATERIAL_VIEW_FULL */] + '&Token=' + Object(auth["a" /* getToken */])() + '&id=' + materia.id
              };
              srcList.push(src);
            });
            m.previewerSrcList = srcList;
          });
          commit('setMaterialGroupList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var material_mutations = {
  setMaterialGroupList: function setMaterialGroupList(state, materialGroupList) {
    state.materialGroupList = materialGroupList;
  }
};

/* harmony default export */ var my_material = ({
  namespaced: true,
  state: material_state,
  getters: material_getters,
  actions: material_actions,
  mutations: material_mutations
});
// EXTERNAL MODULE: ./src/api/my/relation.js
var relation = __webpack_require__("b7Zb");

// CONCATENATED MODULE: ./src/store/modules/my/relation.js


// initial state
var relation_state = {
  relationList: [],
  relationInfo: {}

  // getters
};var relation_getters = {
  relationList: function relationList(state) {
    return state.relationList;
  }

  // actions
};var relation_actions = {
  // 关系人列表
  relationListAction: function relationListAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(relation["c" /* relationListApi */])().then(function (response) {
        if (response.status === '2000') {
          commit('setRelationList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 关系人信息
  relationInfoAction: function relationInfoAction(_ref2, query) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(relation["b" /* relationInfoApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setRelationInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var relation_mutations = {
  setRelationList: function setRelationList(state, relationList) {
    state.relationList = relationList;
  },
  setRelationInfo: function setRelationInfo(state, relationInfo) {
    state.relationInfo = relationInfo;
  }
};

/* harmony default export */ var my_relation = ({
  namespaced: true,
  state: relation_state,
  getters: relation_getters,
  actions: relation_actions,
  mutations: relation_mutations
});
// EXTERNAL MODULE: ./src/api/guide/index.js
var guide = __webpack_require__("0lxw");

// CONCATENATED MODULE: ./src/store/modules/guide/index.js


// initial state
var guide_state = {
  topicList: [],
  articleList: [],
  topicInfo: {
    specialTopic: {}
  },
  articleInfo: {},
  articleComment: {},
  articleNotaryList: []

  // getters
};var guide_getters = {};

// actions
var guide_actions = {
  // 获取专题
  topicListAction: function topicListAction(_ref) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["h" /* topicListApi */])().then(function (response) {
        if (response.status === '2000') {
          commit('setTopicList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取专题详情
  topicInfoAction: function topicInfoAction(_ref2, qurey) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["g" /* topicInfoApi */])(qurey).then(function (response) {
        if (response.status === '2000') {
          commit('setTopicInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取公证知识与问题
  articleListAction: function articleListAction(_ref3, query) {
    var commit = _ref3.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["e" /* articleListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setArticleList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取公证知识与问题详情
  articleInfoAction: function articleInfoAction(_ref4, query) {
    var commit = _ref4.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["c" /* articleInfoApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setArticleInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取公证知识与问题详情评论
  articleCommentAction: function articleCommentAction(_ref5, query) {
    var commit = _ref5.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["b" /* articleCommentListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setArticleComment', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取公证知识与问题详情相关业务
  articleNotaryListAction: function articleNotaryListAction(_ref6, query) {
    var commit = _ref6.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(guide["f" /* articleNotaryListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setArticleNotaryListInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var guide_mutations = {
  setTopicList: function setTopicList(state, topicList) {
    state.topicList = topicList;
  },
  setTopicInfo: function setTopicInfo(state, topicInfo) {
    state.topicInfo = topicInfo;
  },
  setArticleList: function setArticleList(state, articleList) {
    state.articleList = articleList;
  },
  setArticleInfo: function setArticleInfo(state, articleInfo) {
    state.articleInfo = articleInfo;
  },
  setArticleComment: function setArticleComment(state, articleComment) {
    state.articleComment = articleComment;
  },
  setArticleNotaryListInfo: function setArticleNotaryListInfo(state, articleNotaryList) {
    state.articleNotaryList = articleNotaryList;
  }
};

/* harmony default export */ var modules_guide = ({
  namespaced: true,
  state: guide_state,
  getters: guide_getters,
  actions: guide_actions,
  mutations: guide_mutations
});
// EXTERNAL MODULE: ./src/api/my/bid.js
var bid = __webpack_require__("VITs");

// CONCATENATED MODULE: ./src/store/modules/my/bid.js




// initial state
var bid_state = {
  orderList: {},
  orderInfo: {
    orderBaseInfo: {},
    orderProposerList: {},
    orgInfo: {},
    orderExtraCostList: {},
    orderNotaryList: {},
    costViewSwitch: {},
    orderAddServiceList: {},
    orderEvidList: {}
  },
  orderInstrument: {},
  orderMaterial: {},
  orderOrgPay: {},
  orderMsgList: []

  // getters
};var bid_getters = {};

// actions
var bid_actions = {
  // 订单列表
  orderListAction: function orderListAction(_ref, query) {
    var commit = _ref.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["g" /* orderListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setOrderList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 订单列表
  orderInfoAction: function orderInfoAction(_ref2, query) {
    var commit = _ref2.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["e" /* orderInfoApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setOrderInfo', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 订单列表
  removeOrderInfoAction: function removeOrderInfoAction(_ref3) {
    var commit = _ref3.commit;

    commit('setOrderInfo', {});
  },

  // 订单文书
  orderInstrumentAction: function orderInstrumentAction(_ref4, query) {
    var commit = _ref4.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["f" /* orderInstrumentApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setOrderInstrument', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 订单材料
  orderMaterialAction: function orderMaterialAction(_ref5, query) {
    var commit = _ref5.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["j" /* orderMaterialListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          response.data.orderMaterialList.forEach(function (m) {
            m.needMaterialList.forEach(function (materia) {
              var srcList = [];
              if (materia.orderProposerMaterialList) {
                materia.orderProposerMaterialList.forEach(function (orderProposerMateria) {
                  var src = {
                    src: static_api["b" /* MATERIAL_VIEW_FULL */] + '&Token=' + Object(auth["a" /* getToken */])() + '&id=' + orderProposerMateria.id
                  };
                  srcList.push(src);
                });
              }
              materia.previewerSrcList = srcList;
              var data = {
                orderId: query.orderId,
                materialCode: materia.materialCode,
                orgNotaryIds: materia.orgNotaryIds
              };
              materia.orderMaterialDesc = {
                materialDetailSynopsis: '',
                hasValue: false
              };
              Object(bid["i" /* orderMaterialDescApi */])(data).then(function (res) {
                if (res.status === '2000') {
                  materia.orderMaterialDesc = res.data === null ? {} : res.data;
                  if (materia.orderMaterialDesc.materialDetail && materia.orderMaterialDesc.materialDetail.length > 0 || materia.orderMaterialDesc.materialAttachment && materia.orderMaterialDesc.materialAttachment.length > 0 || materia.orderMaterialDesc.notaryMaterialDetailList && materia.orderMaterialDesc.notaryMaterialDetailList.length > 0) {
                    materia.orderMaterialDesc.hasValue = true;
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetail === null ? '' : materia.orderMaterialDesc.materialDetail;
                    if (materia.orgNotaryIds && materia.orgNotaryIds !== '') {
                      var orgNotaryIdsArr = materia.orgNotaryIds.split(',');
                      if (materia.orderMaterialDesc.notaryMaterialDetailList && materia.orderMaterialDesc.notaryMaterialDetailList.length > 0 && orgNotaryIdsArr.length === materia.orderMaterialDesc.notaryMaterialDetailList.length) {
                        materia.orderMaterialDesc.materialDetailSynopsis = '';
                        materia.orderMaterialDesc.materialDetail = '';
                        materia.orderMaterialDesc.materialAttachment = [];
                        materia.orderMaterialDesc.notaryMaterialDetailList.forEach(function (notaryMaterialDetailObj, index) {
                          if (notaryMaterialDetailObj.notaryMaterialDetail && notaryMaterialDetailObj.notaryMaterialDetail.length > 0) {
                            materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis + notaryMaterialDetailObj.notaryMaterialDetail;
                          }
                        });
                      }
                    }
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/<\/?.+?>/g, '');
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/ /g, '');
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/[\r\n]/g, '');
                  }
                  commit('setOrderMaterial', response.data);
                }
              });
            });
          });
          commit('setOrderMaterial', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 订单列表
  removeOrderMaterialAction: function removeOrderMaterialAction(_ref6) {
    var commit = _ref6.commit;

    commit('setOrderMaterial', {});
  },

  // 订单支付方式
  orderOrgPayAction: function orderOrgPayAction(_ref7, query) {
    var commit = _ref7.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["o" /* orderOrgPayApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setOrderOrgPay', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 订单留言列表
  orderMsgListAction: function orderMsgListAction(_ref8, query) {
    var commit = _ref8.commit;

    return new promise_default.a(function (resolve, reject) {
      Object(bid["m" /* orderMsgListApi */])(query).then(function (response) {
        if (response.status === '2000') {
          commit('setOrderMsgList', response.data);
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

// mutations
var bid_mutations = {
  setOrderList: function setOrderList(state, orderList) {
    state.orderList = orderList;
  },
  setOrderInfo: function setOrderInfo(state, orderInfo) {
    state.orderInfo = orderInfo;
  },
  setOrderInstrument: function setOrderInstrument(state, orderInstrument) {
    state.orderInstrument = orderInstrument;
  },
  setOrderMaterial: function setOrderMaterial(state, orderMaterial) {
    state.orderMaterial = orderMaterial;
  },
  setOrderOrgPay: function setOrderOrgPay(state, orderOrgPay) {
    state.orderOrgPay = orderOrgPay;
  },
  setOrderMsgList: function setOrderMsgList(state, orderMsgList) {
    state.orderMsgList = orderMsgList;
  }
};

/* harmony default export */ var my_bid = ({
  namespaced: true,
  state: bid_state,
  getters: bid_getters,
  actions: bid_actions,
  mutations: bid_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  modules: {
    dict: dict,
    user: modules_user,
    index: modules_index,
    onlineIndex: online,
    org: org,
    collect: my_collect,
    material: my_material,
    relation: my_relation,
    guide: modules_guide,
    bid: my_bid
  }
}));

/***/ }),

/***/ "JDMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K/Cy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAEXklEQVRoge3Za4iVRRgH8N+uq6WVl7SwDEqUoNQ+FGnRh9IyLU2NwKAL2m0DIYXqo1kRFRRlN4I1KrESkrSLVnZDyqIbffJCkEagFaKWK5KlmX2YWfZ19tzec96ziPiHw77nP8888/zPO/PMPLMtHR0dmojr8Ep8vh2rix6gvb0dtBbtOIMrsRLD4mclJjdrsGYJmYD30DfD9cW7uKQZAzZDyDh8iAEl2vrHtnFFD1q0kNH4CEMq2AzGx9G2MBQpZATW4oyEfx7PJtxwQcxZRQ3eVpCfoYKIUQn/OhbE58GYk2kbKUyzidjVaABFvJGT8QHGJvxqzMXh+LlDWOxZjMX70UdDaFRIPyE7jU/4dZiNQxnuUOTWJbbjo49+jQTSiJA+eFOYGll8h1n4u0SfA5gRbbKYGH31qTeYeoW04GUh4Cw2Yzr2Vui7D9diY8LPij5b6gmoXiGLHblw4RdMwc4a+u/GVGxN+DnRd27UI+RB3ZmoCzuE48f2HH5+FcT8nvALsChvUHmFzMdDCdcpiNiSd/DYZwr+TPiHcU8eR3mE3KrnxrZf+FU35Bk0wQZcg78S/jncUquTWoXMwNKEO4iZ+KZCvxZcET+V8G0c42DCL418VdQiZBJWJLb/4SZ8UqXv48K+sQ6PVbH9DDdG310ol+J7oJqQCXgHJyR8O96q5lyYjl1Is1wpvI07E+7EGMPFlTpWEjIGa3BKwt8v5PtacFKZ50p4Ffcm3EDhGHReuU7lhIwUjuPDEv5RPFVjQI1gMR5JuGHCVD67VIdSQobHDiMS/kUsbDDAPFiEFxJuhLCWTkuNUyGDBRHpcXy5nHm9IMwXSoEsRuFTDMqS2XpkgFBTpMfxNbjNkdkkxbm4OXUulLbZ52eS9r1YpvxmelgoBQYJNzJduEBYM5PF/aclXgf1iwGntxyfCwe8dLPKYih+Urm8rYTdQtm7p4JNf6FuSdPwWsxsb28/0Crk6uV6ivhB2PAqiSCkxXpFEH6IC6vY7Mf1+D7hp+K1JUuW9GkVMsQNicGPwrGhUyh8pitfFm/EP7XHXTLITWXa2uLYF8VYpgmlQhaz8UQb7koatglvZ6ewOb0U+VV6CiaceK+OtgOTtmm6f4B/hemRxd7of0cZISuEN0HYUJcJh8z1OCdjN6+lo6PjN903H7twqe7F9yUuy3Q4Vc+TaiXs0Z0AOoWsWCuG4I/M9y9weXweja9wevy+vVXICpuF8nOSIzNIeimQZqVmIh0r+30LrhJi3oS5bcL90pjeia1QbMCE3rjE7lU0W0g2m5W6VSkMzRayusxz4SjqyrQc5gnZBd5o5kDNFnJAqC+ajuOL/WjDcSFHG+pd7INwn56HxEbRiafj31yoV8jdeKDOvtWwD0/m7VTv1Ppa5X8d1IvO6Ds36n0j6/XuSbgqjpnFfswIyTu1zpevymsEZ+YxziskrbmPGhwzU6uakG29EkVt+LlSYzUhC6s56CVsVeUfpP8DY9rMA3XtEsIAAAAASUVORK5CYII="

/***/ }),

/***/ "L2JU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js + 7 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__("Y81h");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// EXTERNAL MODULE: ./src/components/tabBar.vue + 3 modules
var tabBar = __webpack_require__("4B0c");

// EXTERNAL MODULE: ./src/components/consult.vue + 3 modules
var consult = __webpack_require__("dEBp");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var count = this.scrollable ? window.innerWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2507d984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: tab_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_tab_tab = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function injectStyle (ssrContext) {
  __webpack_require__("/GbR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  tab_tab,
  components_tab_tab,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/sticky/sticky.js
var sticky = __webpack_require__("58JO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f41544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/sticky/index.vue
var sticky_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-sticky-box"},[_vm._t("default")],2)}
var sticky_staticRenderFns = []
var sticky_esExports = { render: sticky_render, staticRenderFns: sticky_staticRenderFns }
/* harmony default export */ var vux_src_components_sticky = (sticky_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/sticky/index.vue
function sticky_injectStyle (ssrContext) {
  __webpack_require__("cCFO")
}
var sticky_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticky___vue_template_functional__ = false
/* styles */
var sticky___vue_styles__ = sticky_injectStyle
/* scopeId */
var sticky___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticky___vue_module_identifier__ = null
var sticky_Component = sticky_normalizeComponent(
  src_components_sticky,
  vux_src_components_sticky,
  sticky___vue_template_functional__,
  sticky___vue_styles__,
  sticky___vue_scopeId__,
  sticky___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_sticky = (sticky_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("D5u3")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["a" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}))])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("zl/4")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("QhPJ")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("u0ba")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589c23ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}))],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("5+/f")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca2d6776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("967l")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("bjGu")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){_vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){_vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("C296")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth || 'auto',
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent.labelWidth || this.$parent.$parent.labelWidth || 'auto',
        textAlign: this.$parent.labelAlign || this.$parent.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747bc0aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{labelClass:"weui-label",labelStyle:_vm.labelStyles,labelTitle:_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){_vm.onHide(false)},"on-click-right":function($event){_vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("H/tP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76aee302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])])])}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("U4t6")
  __webpack_require__("JDMP")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74122906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("ptZo")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var src_components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99a60e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var vux_src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("G4+f")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  src_components_scroller,
  vux_src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_scroller = (scroller_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  created: function created() {
    var _this = this;

    this.$navigation.on('back', function (to, from) {
      if (from.route.query.loginBackNum && (from.route.query.loginBackNum === -2 || from.route.query.loginBackNum === '-2')) {
        _this.$router.go(-1);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  created: function created() {
    var _this = this;

    this.$navigation.on('back', function (to, from) {
      if (from.route.query.loginBackNum && (from.route.query.loginBackNum === -2 || from.route.query.loginBackNum === '-2')) {
        _this.$router.go(-1);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e983c63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation',[_c('router-view')],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Us+s")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/styles/theme.less
var theme = __webpack_require__("UL0t");
var theme_default = /*#__PURE__*/__webpack_require__.n(theme);

// EXTERNAL MODULE: ./src/styles/index.less
var styles = __webpack_require__("CJFh");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.css
var nprogress_nprogress = __webpack_require__("UVIz");
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);

// EXTERNAL MODULE: ./src/store/index.js + 13 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/vue-meta-info/lib/vue-meta-info.js
var vue_meta_info = __webpack_require__("5K15");
var vue_meta_info_default = /*#__PURE__*/__webpack_require__.n(vue_meta_info);

// EXTERNAL MODULE: ./node_modules/vue-navigation/dist/vue-navigation.esm.js
var vue_navigation_esm = __webpack_require__("DRgf");

// EXTERNAL MODULE: ./node_modules/vue-touch/dist/vue-touch.js
var vue_touch = __webpack_require__("I0MY");
var vue_touch_default = /*#__PURE__*/__webpack_require__.n(vue_touch);

// CONCATENATED MODULE: ./src/main.js







































fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].component('consult', consult["a" /* default */]);
vue_esm["a" /* default */].component('tab-bar', tabBar["a" /* default */]);

vue_esm["a" /* default */].component('group', group["a" /* default */]);
vue_esm["a" /* default */].component('tab', src_components_tab_tab);
vue_esm["a" /* default */].component('tab-item', src_components_tab_tab_item);
vue_esm["a" /* default */].component('sticky', node_modules_vux_src_components_sticky);
vue_esm["a" /* default */].component('x-button', vux_src_components_x_button);
vue_esm["a" /* default */].component('swiper', vux_src_components_swiper_swiper);
vue_esm["a" /* default */].component('tabbar', src_components_tabbar_tabbar);
vue_esm["a" /* default */].component('tabbar-item', src_components_tabbar_tabbar_item);
vue_esm["a" /* default */].component('popup-picker', vux_src_components_popup_picker);
vue_esm["a" /* default */].component('picker', vux_src_components_picker);
vue_esm["a" /* default */].component('previewer', vux_src_components_previewer);
vue_esm["a" /* default */].component('x-dialog', x_dialog["a" /* default */]);
vue_esm["a" /* default */].component('icon', icon["a" /* default */]);
vue_esm["a" /* default */].component('load-more', vux_src_components_load_more);
vue_esm["a" /* default */].component('scroller', node_modules_vux_src_components_scroller);
vue_esm["a" /* default */].component('popup', node_modules_vux_src_components_popup);
vue_esm["a" /* default */].component('swiper-item', src_components_swiper_swiper_item);

nprogress_default.a.inc(0.2);
nprogress_default.a.configure({ easing: 'ease', speed: 500, showSpinner: false });

router["a" /* default */].beforeEach(function (to, from, next) {
  nprogress_default.a.start();

  store["a" /* default */].commit('dict/setLoginBackFullPath', from.fullPath);

  if (!store["a" /* default */].getters['dict/dictData'] || !store["a" /* default */].getters['dict/dictData'].region) {
    store["a" /* default */].dispatch('user/getUserInfoAction').then(function () {
      var dictData = JSON.parse(window.localStorage.getItem('dictData'));
      var locationInfo = JSON.parse(window.localStorage.getItem('locationInfo'));
      if (dictData && locationInfo && to.path !== '/h5' && to.path !== '/h5/index') {
        store["a" /* default */].commit('dict/setDictData', dictData);
        store["a" /* default */].commit('dict/setLocationInfo', locationInfo);
        if (store["a" /* default */].getters['user/userInfo'] && store["a" /* default */].getters['user/userInfo'].loginName && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
          next('/h5');
        } else {
          next();
        }
      } else {
        store["a" /* default */].dispatch('dict/dictDataAction').then(function () {

          store["a" /* default */].dispatch('dict/locationInfoAction');
          if (store["a" /* default */].getters['user/userInfo'] && store["a" /* default */].getters['user/userInfo'].loginName && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
            next('/h5');
          } else {
            next();
          }
        }).catch(function () {
          next();
        });
      }
    }).catch(function () {
      next();
    });
  } else {
    if (store["a" /* default */].getters['user/userInfo'] && store["a" /* default */].getters['user/userInfo'].loginName && (to.path === '/h5/login' || to.path === '/h5/regist' || to.path === '/h5/forget')) {
      next('/h5');
    } else {
      next();
    }
  }
});

router["a" /* default */].afterEach(function () {
  nprogress_default.a.done();
});

vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);
vue_esm["a" /* default */].use(datetime["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(vue_meta_info_default.a);
vue_esm["a" /* default */].use(vue_navigation_esm["a" /* default */], { router: router["a" /* default */], store: store["a" /* default */], moduleName: 'navigation', keyName: 'VIEW_KEY' });
vue_esm["a" /* default */].use(vue_touch_default.a, { name: 'v-touch' });
vue_esm["a" /* default */].prototype.$alert = function (title, msg) {
  this.$vux.alert.show({
    title: title,
    content: msg
  });
};

vue_esm["a" /* default */].prototype.$toast = function (title) {
  this.$vux.toast.text(title, 'middle');
};

/* eslint-disable no-new */
var app = new vue_esm["a" /* default */]({
  router: router["a" /* default */],
  store: store["a" /* default */],
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/* harmony default export */ var main = __webpack_exports__["default"] = (app);

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./error/404.vue": [
		"34W9",
		35
	],
	"./error/500.vue": [
		"ExNb",
		34
	],
	"./guide/article.vue": [
		"aggf",
		0,
		33
	],
	"./guide/index.vue": [
		"NIBp",
		0,
		6
	],
	"./guide/topic.vue": [
		"A4WB",
		0,
		32
	],
	"./index/about.vue": [
		"TxkT",
		1
	],
	"./index/contact.vue": [
		"IWnN",
		31
	],
	"./index/index.vue": [
		"JXTs",
		0,
		30
	],
	"./index/search.vue": [
		"TRIl",
		0,
		11
	],
	"./index/searchInput.vue": [
		"jn19",
		0
	],
	"./index/weapp.vue": [
		"Y13u",
		12
	],
	"./my/bid.vue": [
		"ON9Y",
		29
	],
	"./my/book.vue": [
		"Rpcf",
		28
	],
	"./my/collect.vue": [
		"FFW+",
		0,
		27
	],
	"./my/fee.vue": [
		"fSjd",
		26
	],
	"./my/index.vue": [
		"xtOy",
		0,
		2
	],
	"./my/material.vue": [
		"HEu9",
		0,
		25
	],
	"./my/modifyPwd.vue": [
		"0Nlf",
		0,
		9
	],
	"./my/msg.vue": [
		"e/YT",
		0,
		3
	],
	"./my/orderDetail.vue": [
		"mZRs",
		0,
		10
	],
	"./my/pay.vue": [
		"9+cx",
		0,
		5
	],
	"./my/relation.vue": [
		"k06C",
		0,
		24
	],
	"./my/relationDetail.vue": [
		"zdyC",
		0,
		23
	],
	"./my/relationEdit.vue": [
		"iOiX",
		0,
		22
	],
	"./my/set.vue": [
		"yBRM",
		21
	],
	"./my/upload.vue": [
		"ucp5",
		0,
		20
	],
	"./online/detail.vue": [
		"aqCT",
		0,
		19
	],
	"./online/detailProd.vue": [
		"xjXz",
		0,
		18
	],
	"./online/index.vue": [
		"nH0Z",
		0,
		17
	],
	"./online/position.vue": [
		"6TqM",
		0,
		16
	],
	"./org/detail.vue": [
		"G2Ci",
		0,
		13
	],
	"./org/index.vue": [
		"pSCj",
		0,
		15
	],
	"./user/forget.vue": [
		"mjJu",
		0,
		7
	],
	"./user/login.vue": [
		"XVVD",
		0,
		14
	],
	"./user/regist.vue": [
		"xwdy",
		0,
		8
	],
	"./user/secret.vue": [
		"KFu7",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "QIbA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAEXElEQVRoge3Za4iVRRgH8N9ZL6WZGloYCiVKEGofjLQblJZoZWoFBl3QSvqWQkSfZGuLLhRhN/oSlXQRiqSLlna11KALIbUqQRqBVkRKKVtrip0+zCzndXbP5T2XZRH/8LKz/3fmmed/zswz8zynUOzQSlyLF2P7dqxr+gztRdDWdMMlXIG1GBuftZjTqslaJWQm3sWQDDcE7+DCVkzYCiHTsAHD+3g3LL6b1uxJmy1kMj7AaRX6jMaHsW/T0Ewh47ERZyb8M3gq4cYJYiY0a/LBTbIzRhAxKeFfxYrYHo0lmXcThWU2C/sadaAZ38gIvI+pCb8OS1GMzx3CZs9iKt6LNhpCo0KGCtFpRsJvwmIczXBHI7cp6Tsj2hjaiCONCBmE14WlkcXXWIRDfYw5jAWxTxazoq1B9TpTr5ACXhAczmIn5uNghbFduBrbE35RtFmox6F6haxy7MaFnzEXf9Qwfj/mYXfCL4m2c6MeIfcpRaIe/C5cP/bmsPOLIOa3hF+B9rxO5RWyHPcn3AFBxK68k8cxc/FnwnfgrjyG8gi5Ve+DrVv4VDvzTJqgE1fhn4R/GrfUaqRWIQuwOuGOYCG+rDCugMvjUwlfxTmOJPzqyFdFLUJm442k73+4CR9VGfuIcG5swsNV+n6CG6PtHpQL8b1QTchMvI2TEv5OvFnNuLAce5BGub7wFpYl3MnRhwsqDawkZArW49SEv0eI97XglDLtSngJdyfcSOEadG65QeWETBSu42MT/iE8UaNDjWAVHky4scJSPquvAX0JGRcHjE/457CyQQfzoB3PJtx4YS+dnnZOhYwWRKTX8TVyxvUmYbmQCmQxCR9jVJbM5iPDhZwivY6vx22OjSYpzsHNqXEhtc22n0zeH8TLyh+mRSEVGCVUZHpwnrBn5ojnTyGWg4ZGh9Mqx+fCBS89rLIYgx9VTm8rYb+Q9v5Voc8wIW9Jw/BGLNRePNwmxOo1eov4VjjwKokghMV6RRA+iOlV+nTjOnyT8PPwigcKg9qECHFD0uEH4dpwQEh85iufFm/Hv7X73aeTO8q8GxznPj/6co2QKmSxGI8Vih26hUOnB3twsXCTXYbnI/8p7i0z4XQhn0jPikuVkqWj2Jq8/1s4BLeVsfu40nJaIuynCdiCszP9DhWKHX5Vqnzsw0VKm28rLskMmK1y0pTiM6V8vEv1O1cWI4UPrwebcVlsT8YXOCP+v7dNiAo7hfRztmMjSFoUaLhIkAPpXNmIuAtXCj7vwNLBQn1pSv/41lR0YmZ/FLH7Fa0WcrhMu+lotZAtmfbmVk7UrJJpOTyK72J7QysnarWQI0IVseU4sdkHGk4IGWiod7OPEIpntRYUakUXXot/c6FeIdfrXbZpFrqFW24u1Lu0OoUreLPRhe/rGVjvN7JN6Uo9IHDcbPbjRkjepTVR/yVXvYpwlZBXSPr7yIDBcbO0qgnZ0y9e1IafKr2sJmRlNQP9hN2q/ED6P7d3zI1q3J+kAAAAAElFTkSuQmCC"

/***/ }),

/***/ "QhPJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RtM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bannerListApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = bidHotApi;
/* harmony export (immutable) */ __webpack_exports__["e"] = searchResultApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = searchHotApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = searchNumApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");

/**
 * 获取首页Banner
 */
function bannerListApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/banner/list',
    method: 'get'
  });
}

/**
 * 首页热门申办
 */
function bidHotApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/online/bid_hot',
    method: 'get'
  });
}

/**
 * 搜索
 */
function searchResultApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/search/result',
    method: 'get',
    params: query
  });
}

/**
 * 热门搜索标签
 */
function searchHotApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/search/hot',
    method: 'get',
    params: query
  });
}

/**
 * 热门搜索标签搜索量加一
 */
function searchNumApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/search/num',
    method: 'post',
    params: query
  });
}

/***/ }),

/***/ "TWC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_cookie_index_js__ = __webpack_require__("17Ff");


var TokenKey = 'Token';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_cookie_index_js__["a" /* default */].get(TokenKey);
}

function setToken(token) {
  return __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_cookie_index_js__["a" /* default */].set(TokenKey, token, {
    path: '/',
    expires: 1
  });
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_vux_src_tools_cookie_index_js__["a" /* default */].remove(TokenKey, {
    path: '/'
  });
}

/***/ }),

/***/ "U4t6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UL0t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ULcu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("W9G5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Us+s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VITs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = orderListApi;
/* harmony export (immutable) */ __webpack_exports__["e"] = orderInfoApi;
/* harmony export (immutable) */ __webpack_exports__["f"] = orderInstrumentApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = orderDelApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = orderBackApi;
/* harmony export (immutable) */ __webpack_exports__["j"] = orderMaterialListApi;
/* harmony export (immutable) */ __webpack_exports__["k"] = orderMaterialUploadApi;
/* harmony export (immutable) */ __webpack_exports__["h"] = orderMaterialApi;
/* harmony export (immutable) */ __webpack_exports__["i"] = orderMaterialDescApi;
/* harmony export (immutable) */ __webpack_exports__["o"] = orderOrgPayApi;
/* harmony export (immutable) */ __webpack_exports__["n"] = orderOfflinePayApi;
/* harmony export (immutable) */ __webpack_exports__["p"] = orderWeiXinPayApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = orderAliPayApi;
/* harmony export (immutable) */ __webpack_exports__["m"] = orderMsgListApi;
/* harmony export (immutable) */ __webpack_exports__["l"] = orderMsgApi;
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelRevocationApi;
/* harmony export (immutable) */ __webpack_exports__["q"] = wxWechatQrCodeApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");


/**
 * 订单列表
 */
function orderListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/list',
    method: 'get',
    params: query
  });
}

/**
 * 订单详情
 */
function orderInfoApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/info',
    method: 'get',
    params: query
  });
}

/**
 * 订单文书
 */
function orderInstrumentApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/instrument',
    method: 'get',
    params: query
  });
}

/**
 * 删除订单
 */
function orderDelApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/del',
    method: 'put',
    data: data
  });
}

/**
 * 撤销订单
 */
function orderBackApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/back',
    method: 'put',
    data: data
  });
}

/**
 * 订单材料
 */
function orderMaterialListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/material_list',
    method: 'get',
    params: query
  });
}

/**
 * 上传材料
 */
function orderMaterialUploadApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/material_upload',
    method: 'post',
    data: data
  });
}

/**
 * 保存订单材料
 */
function orderMaterialApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/material',
    method: 'post',
    data: data
  });
}

/**
 * 材料说明
 */
function orderMaterialDescApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/material_desc',
    method: 'get',
    params: query
  });
}

/**
 * 订单支付方式
 */
function orderOrgPayApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/org_pay',
    method: 'get',
    params: query
  });
}

/**
 * 订单线下支付
 */
function orderOfflinePayApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/offline_pay',
    method: 'post',
    params: query
  });
}

/**
 * 订单微信支付
 */
function orderWeiXinPayApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/wei_xin_pay',
    method: 'post',
    params: query
  });
}

/**
 * 订单支付宝支付
 */
function orderAliPayApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/ali_pay',
    method: 'post',
    params: query
  });
}

/**
 * 订单留言列表
 */
function orderMsgListApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/msg_list',
    method: 'get',
    params: query
  });
}

/**
 * 订单留言
 */
function orderMsgApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/msg',
    method: 'post',
    data: data
  });
}

/**
 * 取消撤销
 */
function cancelRevocationApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/order/cancel_revocation',
    method: 'put',
    data: data
  });
}

/**
 * 取消撤销
 */
function wxWechatQrCodeApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/wx/wechat/qrCode',
    method: 'get',
    params: query
  });
}

/***/ }),

/***/ "W9G5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X9gD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADE0lEQVRoge3azYscRRjH8U9NghhX8QXElxwMaHIw6xrRiyfRaFDUP0A8rO/RmxANQpLR6XiJGvHmKygI/gMmRjBCbp4CMaiXjQdB87JE8OC6ZHFtD9UTZpvuHnd7wvRIf2Ggq+vpp55fddVT3V0T0p56dNPi80nYgF3ZL8W7OKibLubsRtJ+p56XApLQkYRZzGE/rsG12fGcJMxKwsjbHa3DJGzHcXyGjQUWG7O645ntyFg/Ei9JmMZbeOQ/XrENRyXhMHbjp7oh1L0jN0rCRzihXMQCFkvqHsVJfIAb6gSyViFXYB9O4XmsK7BZxse4DZvxqTjp86zDzszXXmxYS0BhlVmrg1m8iZsr7I5gt276w4qzSZjBO3io4trfsAef45+hEWVZazVCHsRBzFTYnMQu3fRopackPIy3MV1hdQKv4NtKX6tIv9P4Ct8oF3Eaz+CuoSJi41/jTjyHMyVWMSFwCLcPc1l1R25CLwuwaA4QJ/IBcaH7a1hjhSRhSuz5VzFVYrWMT/A6zq2oqbgjU9kFc6on8oe4VTfdv2YRkQWxwzaLyWG5wGZoQujkjp/NBLyhvHcOi0PsRfneqccZvCAOqSMlNlfqPyHwtIH4+0Nrh5hN7qho6G8x31dPvtGxXeysqkX7YnIJac8eMZ1OMq+FtOdP5cNoUjjfEYfMpLPcMfnDCg70J/tWXJ+rfE9ctPq8L662RTyFewfKh/Blie3jeGyg/J34aF/ENrw0UP4eL+dsftVNT/Uzwo8FTv7IlX8W3zXKghvkdIXt3bny7xW2VxXEdGzFmUv2hjgmWiFNoxXSNFohTaMV0jRaIU2jFdI0WiFNoxXSNFohTaMV0jT+N0LyH4jvx33Z8aZc3Q5sKfGTP39PRZv5ui3iV/gi8jFsEncKiJ+FjvUrBjd6rsY8LqsIokks4TrddIGVQ2sR58cS0tqYx4V+YXBoLYn7hTOo+QeRS04q7o1c/AAf0p7L8QRuGVdUNfkFX6wXNxmfHHMwdXkgpD0XTM4EL2OpY7QbmuPibEfc9p0fdyQ1OIed/wKgzrSHGzfIoQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/model/index.js
var Import = __webpack_require__("A66B");
/* harmony default export */ var model = ([{
  path: '/h5',
  component: Import('index/index'),
  name: 'index',
  meta: { title: '在线公证平台' },
  redirect: { name: 'indexIndex' }
}, {
  path: '/h5/index',
  component: Import('index/index'),
  name: 'indexIndex',
  meta: { title: '在线公证平台' }
}, {
  path: '/h5/about',
  component: Import('index/about'),
  name: 'about',
  meta: { title: '关于我们' }
}, {
  path: '/h5/contact',
  component: Import('index/contact'),
  name: 'contact',
  meta: { title: '联系我们' }
}, {
  path: '/h5/search',
  component: Import('index/search'),
  name: 'search',
  meta: { title: '搜索' }
}, {
  path: '/h5/weapp',
  component: Import('index/weapp'),
  name: 'weapp',
  meta: { title: '小程序' }
}]);
// CONCATENATED MODULE: ./src/router/model/online.js
var online_Import = __webpack_require__("A66B");
/* harmony default export */ var online = ([{
  path: '/h5/online',
  component: online_Import('online/index'),
  name: 'onlineIndex',
  meta: { title: '在线公证' }
}, {
  path: '/h5/online/position/:type/:code',
  component: online_Import('online/position'),
  name: 'onlinePosition',
  meta: { title: '在线公证' }
}, {
  path: '/h5/online/detail/1/:code',
  component: online_Import('online/detail'),
  name: 'onlineDetail',
  meta: { title: '在线公证' }
}, {
  path: '/h5/online/detail/3/:code',
  component: online_Import('online/detailProd'),
  name: 'onlineDetailProd',
  meta: { title: '在线公证' }
}]);
// CONCATENATED MODULE: ./src/router/model/org.js
var org_Import = __webpack_require__("A66B");
/* harmony default export */ var org = ([{
  path: '/h5/org',
  component: org_Import('org/index'),
  name: 'orgIndex',
  meta: { title: '公证处' }
}, {
  path: '/h5/org/detail/:orgId',
  component: org_Import('org/detail'),
  name: 'orgDetail',
  meta: { title: '公证处详情' }
}]);
// CONCATENATED MODULE: ./src/router/model/user.js
var user_Import = __webpack_require__("A66B");
/* harmony default export */ var user = ([{
  path: '/h5/regist',
  component: user_Import('user/regist'),
  name: 'regist',
  meta: { title: '注册' }
}, {
  path: '/h5/login',
  component: user_Import('user/login'),
  name: 'login',
  meta: { title: '登录' }
}, {
  path: '/h5/forget',
  component: user_Import('user/forget'),
  name: 'forget',
  meta: { title: '重置密码' }
}, {
  path: '/h5/secret',
  component: user_Import('user/secret'),
  name: 'secret',
  meta: { title: '公证云隐私协议' }
}]);
// CONCATENATED MODULE: ./src/router/model/guide.js
var guide_Import = __webpack_require__("A66B");
/* harmony default export */ var guide = ([{
  path: '/h5/guide',
  component: guide_Import('guide/index'),
  name: 'guideIndex',
  meta: { title: '公证指南' }
}, {
  path: '/h5/topic/:topicId',
  component: guide_Import('guide/topic'),
  name: 'topic',
  meta: { title: '专题' }
}, {
  path: '/h5/article/:articleId',
  component: guide_Import('guide/article'),
  name: 'article',
  meta: { title: '文章详情' }
}]);
// CONCATENATED MODULE: ./src/router/model/my.js
var my_Import = __webpack_require__("A66B");
/* harmony default export */ var my = ([{
  path: '/h5/my',
  component: my_Import('my/index'),
  name: 'myIndex',
  meta: { title: '个人中心' }
}, {
  path: '/h5/my/modifyPwd',
  component: my_Import('my/modifyPwd'),
  name: 'modifyPwd',
  meta: { title: '修改密码' }
}, {
  path: '/h5/my/orderDetail/:orderId',
  component: my_Import('my/orderDetail'),
  name: 'orderDetail',
  meta: { title: '订单详情' }
}, {
  path: '/h5/my/upload',
  component: my_Import('my/upload'),
  name: 'myUpload',
  meta: { title: '上传的材料' }
}, {
  path: '/h5/my/collect',
  component: my_Import('my/collect'),
  name: 'myCollect',
  meta: { title: '我的收藏' }
}, {
  path: '/h5/my/bid',
  component: my_Import('my/bid'),
  name: 'myBid',
  meta: { title: '申办人信息' }
}, {
  path: '/h5/my/relation',
  component: my_Import('my/relation'),
  name: 'myRelation',
  meta: { title: '我的关系人' }
}, {
  path: '/h5/my/relationDetail/:relationId',
  component: my_Import('my/relationDetail'),
  name: 'myRelationDetail',
  meta: { title: '我的关系人' }
}, {
  path: '/h5/my/relationEdit/:relationId',
  component: my_Import('my/relationEdit'),
  name: 'myRelationEdit',
  meta: { title: '我的关系人' }
}, {
  path: '/h5/my/fee',
  component: my_Import('my/fee'),
  name: 'myFee',
  meta: { title: '费用详情' }
}, {
  path: '/h5/my/book',
  component: my_Import('my/book'),
  name: 'myBook',
  meta: { title: '文书' }
}, {
  path: '/h5/my/material/:orderId',
  component: my_Import('my/material'),
  name: 'myMaterial',
  meta: { title: '订单材料' }
}, {
  path: '/h5/my/pay',
  component: my_Import('my/pay'),
  name: 'myPay',
  meta: { title: '订单支付' }
}, {
  path: '/h5/my/msg/:orderId',
  component: my_Import('my/msg'),
  name: 'myMsg',
  meta: { title: '订单留言' }
}, {
  path: '/h5/my/set',
  component: my_Import('my/set'),
  name: 'mySet',
  meta: { title: '设置' }
}]);
// CONCATENATED MODULE: ./src/router/model/error.js
var error_Import = __webpack_require__("A66B");
/* harmony default export */ var error = ([{
  path: '/h5/404',
  component: error_Import('error/404'),
  name: 'error_404',
  meta: { title: '404' }
}, {
  path: '/h5/500',
  component: error_Import('error/500'),
  name: 'error_500',
  meta: { title: '500' }
}, {
  path: '*',
  component: error_Import('error/404'),
  name: '404',
  meta: { title: '404' }
}]);
// CONCATENATED MODULE: ./src/router/index.js











vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = __webpack_exports__["a"] = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [].concat(toConsumableArray_default()(model), toConsumableArray_default()(online), toConsumableArray_default()(org), toConsumableArray_default()(user), toConsumableArray_default()(guide), toConsumableArray_default()(my), toConsumableArray_default()(error))
}));

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("bdEq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7Zb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = relationDelApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = relationListApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = relationInfoApi;
/* harmony export (immutable) */ __webpack_exports__["e"] = relationSaveApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = relationOCRApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");

/**
 * 删除关系人
 */
function relationDelApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/relation/del',
    method: 'delete',
    params: query
  });
}

/**
 * 关系人列表
 */
function relationListApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/relation/list',
    method: 'get'
  });
}

/**
 * 关系人信息
 */
function relationInfoApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/relation/info',
    method: 'get',
    params: query
  });
}

/**
 * 保存关系人信息
 */
function relationSaveApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/relation/save',
    method: 'post',
    data: data
  });
}

/**
 * 保存关系人信息
 */
function relationOCRApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/relation/ocr',
    method: 'post',
    data: data
  });
}

/***/ }),

/***/ "bdEq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bjGu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cCFO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8kT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dEBp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consult.vue
//
//
//
//

/* harmony default export */ var consult = ({
  name: 'consult',
  data: function data() {
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/consult.vue
//
//
//
//

/* harmony default export */ var components_consult = ({
  name: 'consult',
  data: function data() {
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b523e0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/consult.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://wpa1.qq.com/fAcIP46m?_type=wpa&qidian=true"}},[_c('div',{staticClass:"consult-fixed"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_consult = (esExports);
// CONCATENATED MODULE: ./src/components/consult.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_consult,
  selectortype_template_index_0_src_components_consult,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_consult = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gkYO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "hQg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hbRj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l/JR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_auth__ = __webpack_require__("TWC+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");






var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://www.egongzheng.com/h5/online-gzy-api", // api的base_url
  timeout: 600000 // request timeout
});
// 设置每次session不变
service.defaults.withCredentials = true;

// request interceptor
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (Object(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* getToken */])() !== undefined) {
    config.headers['Token'] = Object(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["a" /* getToken */])();
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone interceptor
service.interceptors.response.use(
// response => response,
function (response) {
  var res = response.data;
  // 如果有值，需要更新Token，延长用户登录状态
  if (res.token && res.token.length > 0) {
    Object(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["b" /* removeToken */])();
    Object(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["c" /* setToken */])(res.token);
  }
  // 请求失败的情况
  if (res.status !== '2000') {
    // Token 过期,未登录
    if (res.status === '4000') {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('user/logOutAction').then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__auth_auth__["b" /* removeToken */])();
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
          name: 'login'
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__main__["default"].$vux.toast.text(res.message, 'middle');
    }
  }
  return response.data;
}, function (error) {
  console.log('err' + error); // for debug
  if (error.message === 'Network Error') {
    __WEBPACK_IMPORTED_MODULE_1__main__["default"].$vux.toast.text('网络错误', 'middle');
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("4ypi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("68gT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p/NS":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ptZo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("tOHB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("d8kT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tOHB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u0ba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v1eo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = loginApi;
/* harmony export (immutable) */ __webpack_exports__["h"] = userInfoApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkUserApi;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkCodeApi;
/* harmony export (immutable) */ __webpack_exports__["f"] = registerApi;
/* harmony export (immutable) */ __webpack_exports__["g"] = resetPwdApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = goAgreeApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = generateCaptchaApi;
/* harmony export (immutable) */ __webpack_exports__["i"] = verifyCaptchaApi;
/* harmony export (immutable) */ __webpack_exports__["j"] = verifyCaptchaExtApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");


/**
 * 登录
 */
function loginApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/login',
    method: 'post',
    data: data
  });
}

/**
 * 获取用户信息
 */
function userInfoApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/user_info',
    method: 'get'
  });
}

/**
 * 校验用户是否注册
 */
function checkUserApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/check_user',
    method: 'post',
    data: data
  });
}

/**
 * 校验移动端手机验证码
 */
function checkCodeApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/check_code',
    method: 'post',
    data: data
  });
}

/**
 * 注册
 */
function registerApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/register',
    method: 'post',
    data: data
  });
}

/**
 * 重置密码
 */
function resetPwdApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/reset_pwd',
    method: 'post',
    data: data
  });
}

/**
 * 同意协议
 */
function goAgreeApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/verify/agreeProtocol',
    method: 'post',
    data: data
  });
}

// ==================== 图形点选验证码 ====================

/**
 * 生成图形点选验证码
 * @returns {Promise} 验证码数据（captchaId、image、hintIcon、targetCount）
 */
function generateCaptchaApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/captcha/generate',
    method: 'get'
  });
}

/**
 * 校验验证码（仅校验，登录用）
 * @param {Object} data - { captchaId, clicks: [{x, y}] }
 * @returns {Promise} 校验结果，成功时包含 verifyToken
 */
function verifyCaptchaApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/captcha/verify',
    method: 'post',
    data: data
  });
}

/**
 * 校验验证码 + 扩展处理（注册/忘记密码/改密码用）
 * @param {Object} data - { captchaId, clicks: [{x, y}], mobile }
 * @returns {Promise} 校验结果，成功时包含 verifyToken 且已发送短信
 */
function verifyCaptchaExtApi(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/captcha/verify_ext',
    method: 'post',
    data: data
  });
}

/***/ }),

/***/ "zTws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = materialDelApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = materialListApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_request__ = __webpack_require__("l/JR");

/**
 * 删除材料
 */
function materialDelApi(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/material/del',
    method: 'delete',
    params: query
  });
}

/**
 * 材料列表
 */
function materialListApi() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__api_request__["a" /* default */])({
    url: '/auth/material/list',
    method: 'get'
  });
}

/***/ }),

/***/ "zl/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7d3ac54e8fda81a48c24.js